class APIEndPoints {
    static BASE = window.config.awsBaseAddress;
    static GET_SIGNED_URL = this.BASE + 'SignedURL/Upload/';
    static POST_RECIPE = this.BASE + 'Recipes/';
}

export default APIEndPoints;